<ng-form #resetForm="ngForm" appPasswordsMatch class="flex flex-column gap-sm">
  <tui-textfield>
    <input
      placeholder="{{ 'LOGIN.PASSWORD_RESET.NEW_PASSWORD_PLACEHOLDER' | translate }}"
      tuiTextfield
      class="password"
      type="password"
      name="password"
      [(ngModel)]="model.password"
      required
      minlength="8"
      appPasswordValidator
      #passwordModel="ngModel"
      [disabled]="isDisabled()"
      [invalid]="passwordModel.touched && passwordModel.invalid"
      (input)="onCredentialsChange()"
      (focus)="onCredentialsChange()"
      (blur)="onBlur()"
    />
    <tui-icon tuiPassword></tui-icon>
  </tui-textfield>

  <tui-textfield>
    <input
      tuiTextfield
      placeholder="{{ 'LOGIN.PASSWORD_RESET.CONFIRM_PASSWORD_PLACEHOLDER' | translate }}"
      class="password"
      type="password"
      name="passwordConfirm"
      [(ngModel)]="model.passwordConfirm"
      required
      #confirmModel="ngModel"
      [disabled]="isDisabled()"
      [invalid]="confirmModel.touched && (confirmModel.invalid || resetForm.errors?.['passwordsMismatch'])"
      (input)="onCredentialsChange()"
      (focus)="onCredentialsChange()"
      (blur)="onBlur()"
    />
    <tui-icon tuiPassword></tui-icon>
  </tui-textfield>

  @if (areRulesVisible()) {
    <ion-password-rules-panel
      [passwordModel]="passwordModel"
      [passwordConfirmModel]="confirmModel"
      [resetForm]="resetForm"
      [showError]="!!(passwordModel.touched || confirmModel.touched)"
    ></ion-password-rules-panel>
  }
</ng-form>
